module.exports = __webpack_public_path__ + "media/images/proof_links/colored/pinterest-886231930cfa82d04ce17e4086f3e32a.svg";